import { useTranslation } from 'next-i18next';
import React from 'react';
import usePoll from '../../../hooks/usePoll';

interface NoPollActiveProps {
  isMBW?: boolean;
  backgroundColor?: string;
  textColor?: string;
}

const NoPollActive = ({ isMBW, backgroundColor, textColor }: NoPollActiveProps) => {
  const { t } = useTranslation();
  const { getPollBackgroundColor, getPollTextColor } = usePoll();

  return (
    <div
      style={{
        background: isMBW ? '' : getPollBackgroundColor(false, backgroundColor),
        color: isMBW ? '' : getPollTextColor(false, textColor),
      }}
      className={`w-full p-4 break-normal ${isMBW ? 'bg-opacity-10 bg-white text-white' : 'rounded-lg'}`}>
      {isMBW ? (
        <>
          <p className="mb-8">Hinweis</p>
          <span>Sobald eine Umfrage oder eine andere interaktiver Bestandteile startet, leuchtet der Button orange</span>
        </>
      ) : (
        <p>{t('poll:poll-no-active')}</p>
      )}
    </div>
  );
};
export default NoPollActive;
